
export const formatDisplayDate = (dateString) => {
    if (dateString === "" || dateString === null) {
        return "";
    }
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};